<template>
  <BaseAction>
    <PrimaryButton light @click.native="openDialog" fullWidth>
      Add Section +
    </PrimaryButton>
    <AddOfferGroupDialog v-if="isOpen" @close="closeDialog" />
  </BaseAction>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import BaseAction from "@/components/common/BaseAction";
import AddOfferGroupDialog from "@/views/offers/dialogs/AddOfferGroupDialog";

export default {
  name: "AddOfferGroupAction",
  components: {
    BaseAction,
    PrimaryButton,
    AddOfferGroupDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
